import React, { useEffect, useState } from 'react';
import classes from './VideoMenu.module.css';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import { convertToRaw, EditorState } from 'draft-js';
import TextEditor from '../../../components/UI/Inputs/TextEditor';
import { htmlToEditorState } from '../../../utils/textEditorUtils';
import { useAppDispatch } from '../../../store/store';
import {
  editConsultationNote,
  fetchConsultationNotes,
} from '../../../store/slices/consultationNotes';
import draftToHtml from 'draftjs-to-html';

import { useConsultationContext } from '../../../context/ConsultationContext';
import { ContentViewer } from '../../../components/ContentViewer/ContentViewer';
import { useTranslation } from '../../../hooks/useTranslations';
import { toast } from 'react-toastify';
import { CHARACTER_LIMITS, characterLimitMessage } from '../../../utils/characterLimits';

interface Props {
  internalNoteId: number;
  internalNoteText: string;
  isClosed?: boolean;
}

const InternalNotes: React.FC<Props> = ({ internalNoteId, internalNoteText, isClosed }) => {
  let isReports = window.location.pathname.includes('reports');
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const { selectedSalesOrder, workOrderStatusId, internalNotesState, setInternalNotesState } =
    useConsultationContext();
  const isFinalized = workOrderStatusId === 2;
  const [editInternalNotes, setEditInternalNotes] = useState<boolean>(
    selectedSalesOrder?.consultation_notes?.consultation_notes_description === null
  );

  useEffect(() => {
    dispatch(fetchConsultationNotes());
  }, [dispatch, selectedSalesOrder]);

  const onEditorStateChange = (internalNotesState: EditorState) => {
    setInternalNotesState(internalNotesState);
  };

  const handleSave = async () => {
    if (
      internalNotesState.getCurrentContent().getPlainText().length >
      CHARACTER_LIMITS.internalNotes
    ) {
      toast.error(
        characterLimitMessage(
          translations('error.character_limit'),
          CHARACTER_LIMITS.internalNotes
        ),
        { position: toast.POSITION.BOTTOM_RIGHT }
      );
      return;
    }

    const result = await dispatch(
      editConsultationNote({
        consultationsNoteDescription: draftToHtml(
          convertToRaw(internalNotesState?.getCurrentContent())
        ),
        consultationNoteId: internalNoteId,
      })
    );
    if (result.meta.requestStatus === 'fulfilled') {
      setInternalNotesState(EditorState.createEmpty());
      setEditInternalNotes(false);
    }
  };
  const editTab = () => {
    setInternalNotesState(htmlToEditorState(internalNoteText));
    setEditInternalNotes(true);
  };

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {!selectedSalesOrder?.consultation_notes?.consultation_notes_description &&
      isClosed &&
      isReports ? (
        <div className="emptyState">{translations('label.empty_state')}</div>
      ) : (
        <div className={classes.inputs}>
          {editInternalNotes ? (
            <div>
              <div className={classes.textAreaContainer}>
                <TextEditor
                  editorState={internalNotesState}
                  onEditorStateChange={onEditorStateChange}
                />
              </div>
              <PrimaryButtonV2
                text={translations('save')}
                containerStyle={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginRight: '20px',
                }}
                buttonStyle={{
                  width: '150px',
                  height: '40px',
                }}
                disabled={
                  draftToHtml(convertToRaw(internalNotesState?.getCurrentContent())) === '' ||
                  isFinalized
                }
                onClick={handleSave}
              />
            </div>
          ) : (
            <div style={{ padding: '10px' }}>
              <ContentViewer
                title={translations('internal.notes')}
                content={selectedSalesOrder?.consultation_notes?.consultation_notes_description}
                {...(!isClosed ? { editTab: editTab } : {})}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export { InternalNotes };
